import { filtersFormController, tablePageController, translate } from 'magner';
import moderationTable from 'features/moderation/table/gaz';
import { moderationRead } from 'features/moderation/requests/gaz';
import { ModerationList } from 'features/moderation/types/gaz';

const moderationFilters = filtersFormController<ModerationList>({
  actions: [],
  saveToLocalStorage: true,
  submitEvent: 'input',
  pagination: {
    items: 20,
    page: 1,
  },
  filtersInSeparatePanel: true,
  filtersData: {
    search: '',
  },
  sort: {},
  layout: [
    {
      type: 'input',
      name: 'search',
      props: {
        placeholder: translate('hubstr.moderation.filters.search'),
        inputDelay: 250,
      },
    },
  ],
});

const moderationConfig = tablePageController<ModerationList>({
  header: {
    title: translate('hubstr.moderation.table.title'),
    actions: [],
  },
  request: moderationRead,
  table: moderationTable as any,
  filters: moderationFilters,
});

export default moderationConfig;